import React from "react";
import NavBar from "./NavBar";
import PremiumLayout from "./PremiumLayout";
import { Outlet } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";

const Layout: React.FC = () => {
  // Always use premium layout for all users
  return <PremiumLayout />;
};

export default Layout;
